import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();

  const isActiveLink = (path: string) => {
    const [pathname, query] = path.split('?');

    // Match pathname first
    if (location.pathname !== pathname) return false;

    // If no query → normal match
    if (!query) return true;

    const params = new URLSearchParams(query);
    const currentParams = new URLSearchParams(location.search);

    // Compare search param
    return params.get('search') === currentParams.get('search');
  };
  const navItems = [
    { label: 'Home', path: '/home' },
    { label: 'Lottery', path: '/casino/lottery' },
    { label: 'Cricket', path: '/all-sports/Cricket' },
    { label: 'Tennis', path: '/all-sports/Tennis' },
    { label: 'Football', path: '/all-sports/Soccer' },
    { label: 'Table Tennis', path: '/all-sports/Table-tennis' },
    { label: 'Baccarat', path: 'casino/Mac88?search=baccarat' },
    { label: '32 Cards', path: '/casino/Mac88?search=32 cards' },
    { label: 'Teenpatti', path: '/casino/Mac88?search=teenpatti' },
    { label: 'Poker', path: '/casino/Mac88?search=poker' },
    { label: 'Lucky 7', path: '/casino/Mac88?search=lucky' },
    { label: 'Crash', path: '/casino/Spribe/Crash games' },
  ];

  const notAllowedRoutes = ['/all-sports/Table-tennis'];

  const baseClasses = `
    py-[5px]
    relative
    flex items-center justify-center gap-2
    h-[31px]
    px-[15px]
    text-body-inverse
    text-[14px]
    font-semibold
    uppercase
    transition

    after:content-['']
    after:absolute
    after:bottom-0
    after:left-1/2
    after:-translate-x-1/2
    after:h-[2px]
    after:w-0
    after:bg-body-inverse
    after:transition-all
    after:duration-300

    hover:after:w-full
  `;

  return (
    <div className="hidden w-full bg-secondary xl:flex items-center px-[4px] overflow-x-auto whitespace-nowrap py-1">
      {navItems.map((item) => (
        <NavLink
          key={item.label}
          to={item.path}
          onClick={(e) => {
            if (notAllowedRoutes.includes(item.path)) {
              e.preventDefault();
            }
          }}
          className={({}) => `${baseClasses} ${isActiveLink(item.path) ? 'after:w-full' : ''}`}
          end
        >
          {item.label === 'Crash' && (
            <img src="/icons/aviator.png" alt="Crash" className="h-[18px] w-auto animate-pulse" />
          )}
          {item.label}
        </NavLink>
      ))}
    </div>
  );
};

export default Navbar;
